/**
 * BilingualErrorCard — reusable bilingual BN+EN alert card.
 *
 * Used by TaxonomyErrorBanner, RootErrorFallback, and AdminErrorFallback so all
 * three share the same visual chrome. Props supply all text + the action slot.
 */

import { BilingualHeading } from '@repo/ui/components/BilingualHeading';
import type { ReactNode } from 'react';

export interface BilingualErrorCardProps {
  titleBn: string;
  titleEn: string;
  bodyBn: string;
  bodyEn: string;
  errorMessage?: string | null;
  actions: ReactNode;
  role?: 'alert' | 'status';
}

export function BilingualErrorCard({
  titleBn,
  titleEn,
  bodyBn,
  bodyEn,
  errorMessage,
  actions,
  role = 'alert',
}: BilingualErrorCardProps) {
  return (
    <div
      role={role}
      className="border border-rule bg-paper rounded-[var(--radius)] border-t-4 border-t-red px-8 py-6 flex flex-col gap-4 max-w-2xl"
    >
      <BilingualHeading bn={titleBn} en={titleEn} size="md" />

      <p lang="bn" className="text-ink-dim text-sm leading-relaxed">
        {bodyBn}
      </p>
      <p lang="en" className="text-ink-dim text-sm leading-relaxed">
        {bodyEn}
      </p>

      {errorMessage ? (
        <code className="font-mono text-xs bg-paper-card border border-rule rounded px-3 py-2 text-ink-dim break-all">
          {errorMessage}
        </code>
      ) : null}

      {actions}
    </div>
  );
}
